import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import spinnerReducer from 'reducers/spinner'
import auth from 'reducers/auth'
import paginateReducer from 'reducers/paginate'
import reportReducer from 'reducers/report'
import ruptureReducer from 'reducers/rupture'
import stockAdjustmentReducer from 'reducers/stockAdjustment'
import commercialManagementReducer from 'reducers/commercialManagement'
import code8OccurrencesReducer from 'reducers/occurrencescode8'
import menuMissionReducer from 'reducers/menuMission'
import mobileUpdateReducer from 'reducers/mobileUpdate'
import featureCheckReducer from 'reducers/featureCheck'
import menuReducer from 'reducers/menu'
import lmExpressReducer from 'reducers/lmexpress'
import suggestionReducer from 'reducers/suggestion'
import routesReducer from 'reducers/routes'
import homeReducer from 'reducers/home'
import videosReducer from 'reducers/videos'
import analyticsReducer from 'reducers/analytics'
import ircReducer from 'reducers/irc'
import ircSupplyReducer from 'reducers/ircSupply'
import scheduleBlockReducer from 'reducers/scheduleBlock'
import gamaReducer from 'reducers/gama'
import justificationReducer from 'reducers/justifications'
import weeklyBlockReducer from 'reducers/weeklyBlock'
import salesCoachingReducer from 'reducers/salesCoaching'
import rotativeInventoryReducer from 'reducers/rotativeInventory'
import parametersReducer from 'reducers/parameters'
import sectionBlockReducer from 'reducers/sectionBlock'
import higherAdjustmentsReducer from 'reducers/higherAdjustments'
import datasheetManagementReducer from 'reducers/datasheetManagement'
import datasheetFormatReducer from 'reducers/datasheetFormat'
import totalAccuracyReducer from 'reducers/totalAccuracy'
import sectionsAccuracyReducer from 'reducers/sectionsAccuracy'
import logoBrandsReducer from 'reducers/logoBrands'
import kardexReducer from 'reducers/kardex'
import systemParametersReducer from 'reducers/systemParameters'
import adjustmentValuesReducer from 'reducers/adjustmentValues'
import adjustmentDoneReducer from 'reducers/adjustmentDone'
import punctualAdjustApproversReducer from 'reducers/punctualAdjustApprovers'
import linearConferenceReducer from 'reducers/linearConference'
import localUsersReducer from 'reducers/localUsers'
import trackingMonitorReducer from 'reducers/trackingMonitor'
import queryLogReducer from 'reducers/queryLog'
import justificationPaReducer from 'reducers/justificationsPa'
import justificationDemarcateReducer from 'reducers/justificationDemarcate'
import demarcateDisapprovalJustificationReducer from 'reducers/demarcateDisapprovalJustification'
import totemReportsReducer from 'reducers/totemReports'
import totemReportsNewReducer from 'reducers/totemReportsNew'
import stockTransferReportReducer from 'reducer/stockTransferReport'
import helpConfiguration from 'reducers/helpConfiguration'
import pricebannerConfigReducer from 'reducers/pricebannerConfig'
import pricefyReducer from 'reducers/pricefy'
import parcelReducer from 'reducers/parcel'
import logReducer from 'reducers/totemLog'
import delimitReportReducer from 'reducer/delimit'
import depositReducer from 'reducer/deposit'
import depositApprovalReducer from 'reducers/depositApproval'
import useConsumeJustificationReducer from 'reducers/useConsumeJustification'
import JustificationDisapprovalUseAndConsumptionReducer from 'reducer/JustificationDisapprovalUseAndConsumption'
import usageConsumptionApproversReducer from 'reducers/usageConsumptionApprovers'
import exclusionSubtypeReducer from 'reducers/exclusionSubtype'
import usageConsumptionReducer from 'reducers/usageConsumptionReport'
import missionsReducer from 'reducers/missions'
import beepingReportReducer from 'reducers/beepingReport'
import justificationsLinearConferenceReducer from 'reducers/justificationsLinearConference'
import demarcateJustificationsReducer from 'reducers/demarcateJustifications'
import nexpReducer from 'reducers/paramsNexp'
import auditPriceReducer from './auditPrice'
import attributeReducer from './attribute'
import newIrcSupplyReducer from './newIrcSupply'
import paramsSupplyReducer from './paramsSupply'
import stockTransferApproversReducer from './stockTransferApprovers'
import pricebannerParamsReducer from './pricebannerParams';
import pricebannerListReducer from './pricebannerList';
import externalApisReducer from 'reducers/externalApis'
import satisfactionSurveyReducer from './satisfactionSurvey';

// Combine all application reducers
const rootReducer = combineReducers({
  spinnerReducer,
  auth,
  paginateReducer,
  reportReducer,
  ruptureReducer,
  stockAdjustmentReducer,
  code8OccurrencesReducer,
  commercialManagementReducer,
  menuMissionReducer,
  parametersReducer,
  mobileUpdateReducer,
  featureCheckReducer,
  routing: routerReducer,
  menuReducer,
  lmExpressReducer,
  suggestionReducer,
  routesReducer,
  homeReducer,
  videosReducer,
  analyticsReducer,
  ircReducer,
  ircSupplyReducer,
  scheduleBlockReducer,
  weeklyBlockReducer,
  gamaReducer,
  justificationReducer,
  salesCoachingReducer,
  rotativeInventoryReducer,
  sectionBlockReducer,
  higherAdjustmentsReducer,
  datasheetManagementReducer,
  datasheetFormatReducer,
  totalAccuracyReducer,
  sectionsAccuracyReducer,
  logoBrandsReducer,
  kardexReducer,
  systemParametersReducer,
  adjustmentValuesReducer,
  adjustmentDoneReducer,
  linearConferenceReducer,
  punctualAdjustApproversReducer,
  localUsersReducer,
  trackingMonitorReducer,
  queryLogReducer,
  justificationPaReducer,
  justificationDemarcateReducer,
  demarcateDisapprovalJustificationReducer,
  totemReportsReducer,
  totemReportsNewReducer,
  helpConfiguration,
  stockTransferReportReducer,
  pricebannerConfigReducer,
  pricefyReducer,
  parcelReducer,
  logReducer,
  delimitReportReducer,
  depositReducer,
  depositApprovalReducer,
  useConsumeJustificationReducer,
  JustificationDisapprovalUseAndConsumptionReducer,
  usageConsumptionApproversReducer,
  exclusionSubtypeReducer,
  usageConsumptionReducer,
  missionsReducer,
  beepingReportReducer,
  justificationsLinearConferenceReducer,
  demarcateJustificationsReducer,
  nexpReducer,
  auditPriceReducer,
  attributeReducer,
  newIrcSupplyReducer,
  paramsSupplyReducer,
  stockTransferApproversReducer,
  pricebannerParamsReducer,
  pricebannerListReducer,
  externalApisReducer,
  satisfactionSurveyReducer,
})

export default rootReducer
